module.exports = __webpack_public_path__ + "img/excel.5f228de0.svg";